<!-- <app-header [title]="'Política de Privacidad'"/> -->


<div class="container-fluid tw-relative tw-bg-white tw-pb-12 tw-overflow-hidden tw-min-h-[100dvh]">
    <!-- Fondo decorativo inferior derecho -->
 
    <!-- Contenido principal -->
    <div class="tw-relative tw-z-10">
        <!-- Encabezado -->
        <div class="tw-max-w-6xl tw-mx-auto tw-px-4">
            <h2
                class="tw-text-center tw-text-4xl md:tw-text-5xl tw-font-montserrat tw-font-bold tw-pt-12 tw-pb-4 tw-leading-tight mt-4">
                <span class="tw-text-[#F67011]">
                    Política de
                    <span class="tw-text-black">Privacidad</span>
                </span>
            </h2>


            <div class="container">
                <p class="tw-text-justify tw-text-xl tw-mt-4">
                    La presente Política de Privacidad establece los términos en que usa y protege la información que es
                    proporcionada por sus usuarios al momento de utilizar su sitio web. <strong
                        class="tw-text-[#F67011]">Onelink </strong> está comprometida con la seguridad de los datos de
                    sus usuarios. Cuando le pedimos llenar los campos de información personal con la cual usted pueda
                    ser identificado, lo hacemos asegurando que sólo se empleará de acuerdo con los términos de este
                    documento.
                </p>
                <p class="tw-text-justify tw-text-xl tw-mt-4">
                    Sin embargo, esta Política de Privacidad puede cambiar con el tiempo o ser actualizada por lo que le
                    recomendamos y enfatizamos revisar continuamente esta página para asegurarse que está de acuerdo con
                    dichos cambios.
                </p>

                <h2
                    class="tw-text-center tw-text-4xl md:tw-text-5xl tw-font-montserrat tw-font-bold tw-pt-12 tw-pb-4 tw-leading-tight mt-4">
                    <span class="tw-text-[#F67011]">
                        Quiénes
                        <span class="tw-text-black">somos</span>
                    </span>
                </h2>


                <p class="tw-text-justify tw-text-xl tw-mt-4">
                    La dirección de nuestra web es: https://onelink.net.ve/
                </p>

                <h2
                    class="tw-text-center tw-text-4xl md:tw-text-5xl tw-font-montserrat tw-font-bold tw-pt-12 tw-pb-4 tw-leading-tight mt-4">
                    <span class="tw-text-[#F67011]">
                        Información que
                        <span class="tw-text-black">es recogida</span>

                    </span>
                </h2>

                <p class="tw-text-justify tw-text-xl tw-mt-4">
                    Nuestro sitio web podrá recoger información personal, por ejemplo: Nombre, información de contacto,
                    como su dirección de correo electrónica, número telefónico e información demográfica. Así mismo,
                    cuando sea necesario podrá ser requerida información específica para procesar algún pedido o
                    realizar una entrega o facturación. </p>
                <h2
                    class="tw-text-center tw-text-4xl md:tw-text-5xl tw-font-montserrat tw-font-bold tw-pt-12 tw-pb-4 tw-leading-tight mt-4">
                    <span class="tw-text-[#F67011]">
                        Uso de la

                        <span class="tw-text-black">información recogida </span>

                    </span>
                </h2>

                <p class="tw-text-justify tw-text-xl tw-mt-4">
                    Nuestro sitio web emplea la información con el fin de proporcionar el mejor servicio posible,
                    particularmente para mantener un registro de usuarios, de pedidos en caso que aplique, y mejorar
                    nuestros productos y servicios. Es posible que sean enviados correos electrónicos periódicamente a
                    través de nuestro sitio con ofertas especiales, nuevos productos y otra información publicitaria que
                    consideremos relevante para usted o que pueda brindarle algún beneficio, estos correos electrónicos
                    serán enviados a la dirección que usted proporcione y podrán ser cancelados en cualquier momento.
                </p>
                <p class="tw-text-justify tw-text-xl tw-mt-4">
                    <strong class="tw-text-[#F67011]">Onelink</strong> está altamente comprometido para cumplir con el
                    compromiso de mantener su información segura. Usamos los sistemas más avanzados y los actualizamos
                    constantemente para asegurarnos que no exista ningún acceso no autorizado.
                </p>

                <h2
                    class="tw-text-center tw-text-4xl md:tw-text-5xl tw-font-montserrat tw-font-bold tw-pt-12 tw-pb-4 tw-leading-tight mt-4">
                    <span class="tw-text-[#F67011]">
                        Cookies </span>
                </h2>
                <p class="tw-text tw-text-justify tw-text-xl tw-mt-4">
                    Una cookie se refiere a un fichero que es enviado con la finalidad de solicitar permiso para
                    almacenarse en su ordenador, al aceptar dicho fichero se crea y la cookie sirve entonces para tener
                    información respecto al tráfico web, y también facilita las futuras visitas a una web recurrente.
                    Otra función que tienen las cookies es que con ellas las webs pueden reconocerte individualmente y
                    por tanto brindarte el mejor servicio personalizado de su web.
                </p>
                <p class="tw-text tw-text-justify tw-text-xl tw-mt-4">
                    Nuestro sitio web emplea las cookies para poder identificar las páginas que son visitadas y su
                    frecuencia. Esta información es empleada únicamente para análisis estadístico y después la
                    información se elimina de forma permanente. Usted puede eliminar las cookies en cualquier momento
                    desde su ordenador. En este sentido es importante informarle que las cookies ayudan a proporcionar
                    un mejor servicio de los sitios web, estás no dan acceso a información de su ordenador ni de usted,
                    a menos de que usted así lo quiera y la proporcione directamente, visitas a una web.
                </p>
                <p class="tw-text tw-text-justify tw-text-xl tw-mt-4">
                    Usted puede aceptar o negar el uso de cookies, sin embargo, la mayoría de navegadores aceptan
                    cookies automáticamente pues sirve para tener un mejor servicio web. También usted puede cambiar la
                    configuración de su ordenador para declinar las cookies. Si se declinan es posible que no pueda
                    utilizar algunos de nuestros servicios.
                </p>
                <h2
                    class="tw-text-center tw-text-4xl md:tw-text-5xl tw-font-montserrat tw-font-bold tw-pt-12 tw-pb-4 tw-leading-tight mt-4">
                    <span class="tw-text-[#F67011]">
                        Enlaces a
                        <span class="tw-text-black">Terceros </span>

                    </span>
                </h2>
                <p class="tw-text tw-text-justify tw-text-xl tw-mt-4">
                    Este sitio web pudiera contener en laces a otros sitios que pudieran ser de su interés. Una vez que
                    usted de clic en estos enlaces y abandone nuestra página, ya no tenemos control sobre al sitio al
                    que es redirigido y por lo tanto no somos responsables de los términos o privacidad ni de la
                    protección de sus datos en esos otros sitios terceros. Dichos sitios están sujetos a sus propias
                    políticas de privacidad por lo cual es recomendable que los consulte para confirmar que usted está
                    de acuerdo con estas.
                </p>
                <h2
                    class="tw-text-center tw-text-4xl md:tw-text-5xl tw-font-montserrat tw-font-bold tw-pt-12 tw-pb-4 tw-leading-tight mt-4">
                    <span class="tw-text-[#F67011]">
                        Control de su
                        <span class="tw-text-black">información personal </span>

                    </span>
                </h2>
                <p class="tw-text tw-text-justify tw-text-xl tw-mt-4">
                    En cualquier momento usted puede restringir la recopilación o el uso de la información personal que
                    es proporcionada a nuestro sitio web. Cada vez que se le solicite rellenar un formulario, como el de
                    alta de usuario, puede marcar o desmarcar la opción de recibir información por correo electrónico.
                    En caso de que haya marcado la opción de recibir nuestro boletín o publicidad usted puede cancelarla
                    en cualquier momento.
                </p>

                <p class="tw-text tw-text-justify tw-text-xl tw-mt-4">
                    Esta compañía no venderá, cederá ni distribuirá la información personal que es recopilada sin su
                    consentimiento, salvo que sea requerido por un juez con un orden judicial.
                </p>

                <p class="tw-text tw-text-justify tw-text-xl tw-mt-4">
                    Se reserva el derecho de cambiar los términos de la presente Política de Privacidad en cualquier
                    momento.
                </p>

                <h2
                    class="tw-text-center tw-text-4xl md:tw-text-5xl tw-font-montserrat tw-font-bold tw-pt-12 tw-pb-4 tw-leading-tight mt-4">
                    <span class="tw-text-[#F67011]">
                        CONDICIONES </span>
                </h2>
                <p class="tw-text tw-text-justify tw-text-xl tw-mt-4">
                    1. La cobertura está limitada por las prestaciones del punto de acceso AP donde el usuario se esté
                    conectando, el mismo podrá cambiar de AP en el mismo sector o localidad si el plan de cortesía o
                    contratado sigue vigente.
                </p>
                <p class="tw-text tw-text-justify tw-text-xl tw-mt-4">
                    1.1. Planes de cortesía, <strong class="tw-text-[#F67011]">Onelink </strong> podrá otorgar planes de
                    cortesía estableciendo la
                    duración que considere técnica y económicamente viable.
                </p>

                <p class="tw-text tw-text-justify tw-text-xl tw-mt-4">
                    1.2. Luego que el cliente navegue con su plan de cortesía y pruebe el servicio podrá contratar un
                    plan con la cantidad de hora y velocidad que requiera.
                </p>

                <p class="tw-text tw-text-justify tw-text-xl tw-mt-4">
                    2. El acceso a Internet se realizará con los propios dispositivos electrónicos del Usuario.
                </p>

                <p class="tw-text tw-text-justify tw-text-xl tw-mt-4">
                    3. El Usuario asume la responsabilidad exclusiva sobre las actuaciones que se realicen a través del
                    acceso, especialmente respecto a la posible comisión de infracciones penales o administrativas. </p>

                <p class="tw-text tw-text-justify tw-text-xl tw-mt-4">
                    4. Los Usuarios se comprometen a utilizar el Servicio de forma lícita, de acuerdo con lo dispuesto
                    en las presentes condiciones y de forma que no produzcan un perjuicio en los derechos o intereses de
                    <strong class="tw-text-[#F67011]">Onelink </strong>, o de terceros. A título enunciativo y en ningún
                    caso limitativo o excluyente, el Usuario se compromete a:
                </p>

                <p class="tw-text tw-text-justify tw-text-xl tw-mt-4">
                    – No incurrir en actividades ilegales o contrarias al orden público o a la buena fe.
                </p>
                <p class="tw-text tw-text-justify tw-text-xl tw-mt-4">
                    – No utilizar el Servicio para el envío de comunicaciones no solicitadas (spam).: </p>


                <p class="tw-text tw-text-justify tw-text-xl tw-mt-4">
                    – No realizar acciones que supongan o conlleven una violación de los derechos de propiedad
                    intelectual de <strong class="tw-text-[#F67011]"> Onelink, o de terceros.</strong> </p>


                      <p class="tw-text tw-text-justify tw-text-xl tw-mt-4">
                   – No provocar daños en los sistemas físicos y lógicos de<strong class="tw-text-[#F67011]"> 
                       Onelink,
                   </strong>  de sus proveedores o de terceras persona</p>


                   <p class="tw-text tw-text-justify tw-text-xl tw-mt-4">– No introducir o difundir en la red virus informáticos o utilizar cualesquiera otros sistemas físicos o lógicos que sean susceptibles de provocar los daños anteriormente mencionados.</p>


                    <p class="tw-text tw-text-justify tw-text-xl tw-mt-4">–  No suprimir, alterar, eludir o manipular cualquier dispositivo de protección o sistema de seguridad del Servicio.</p>

                    <p class="tw-text tw-text-justify tw-text-xl tw-mt-4">
                        5. La utilización del Servicio y el acceso a internet que se brinda a través de él se realizan bajo el propio riesgo del Usuario, por lo que, ni <strong class="tw-text-[#F67011]">Onelink </strong>, ni sus administradores, trabajadores, proveedores o colaboradores serán responsables por los daños, de cualquier naturaleza, ejemplos. interrupciones, virus informáticos, desconexiones; de retrasos o bloqueos en el uso del Servicio; ni tampoco de cualquier otra alteración que se pueda producir en el Software o Hardware de los Usuarios. Tampoco garantiza la ausencia de virus, malwares, troyanos u otros elementos que puedan producir alteraciones en el sistema informático, documentos o ficheros del Usuario, excluyendo cualquier responsabilidad por los daños de cualquier clase causados al Usuario por este motivo. De igual manera, <strong class="tw-text-[#F67011]">Onelink </strong>, no responderá por los daños causados por otros usuarios o terceras personas mediante intromisiones ilegítimas fuera de su control.
                    </p>


                    <p class="tw-text tw-text-justify tw-text-xl tw-mt-4">
                       6. <strong class="tw-text-[#F67011]">Onelink </strong> se reserva el derecho de suspender o cancelar el acceso al Servicio en cualquier momento y especialmente, aunque de manera no limitativa, a aquellos usuarios que incumplan las presentes condiciones; en caso de problemas técnicos o de seguridad imprevistos; o en cumplimiento de un requerimiento y/o de una orden policial, judicial o administrativa. Dicha cancelación o suspensión no dará lugar a ningún tipo de indemnización
                    </p>

                      <p class="tw-text tw-text-justify tw-text-xl tw-mt-4">
                     7. El acceso al Servicio y su utilización implican necesariamente que todas y cada una de las presentes condiciones son expresamente aceptadas por usted.
                    </p>
            </div>
        </div>


    </div>
</div>